interface KeyedObject {
    key: string;
}

/**
 * Ensures that the first item with key: "undo" in visibleItems + overflowItems
 * is somewhere in visibleItems
 *
 * Mutates visibleItems and overflowItems in place.
 */
export default function ensureUndoVisible<T extends KeyedObject>(
    visibleItems: T[],
    overflowItems: T[]
) {
    // Exit early if there are no visible items to evict,
    // or if we would evict the overflow button.
    if (visibleItems.length <= 1) {
        return;
    }
    const matchesKey = button => button.key === 'undo';
    const matchingButtonsInOverflow = overflowItems.filter(matchesKey);

    // Exit early if there are no pinned buttons in the overflow, or if
    // the first item with the key is already visible in the visible items.
    if (matchingButtonsInOverflow.length == 0 || visibleItems.some(matchesKey)) {
        return;
    }

    const matchingButton = matchingButtonsInOverflow[0];
    const lastVisibleItem = visibleItems.pop();
    visibleItems.push(matchingButton);
    // remove undo from the list
    overflowItems.splice(overflowItems.indexOf(matchingButton), 1);
    // splice in the last visible item
    overflowItems.splice(0, 0, lastVisibleItem);
}
